export default "__VITE_PUBLIC_ASSET__5b1118cb__"